import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import collaboratorsReducer from './collaborators/data/reducer';
import collaboratorsSaga from './collaborators/data/sagas';
import contactAndAccountNotes from './contactAndAccountNotes/data/reducer';
import contactAndAccountNotesSaga from './contactAndAccountNotes/data/sagas';
import { importHistoricalWorkReducer } from './importHistoricalWork/data/reducers';
import quoteDetailsReducer from './quoteDetailsPage/data/reducer';
import facilitateOrderDrawer from './quoteDetailsPage/modals/FacilitateOrderDrawer/data/reducer';
import quoteItemComponents from './quoteItemComponents/index';
import quoteItemNav from './quoteItemNav/index';
import { appsReducer as quoteItemAppsReducer } from './quoteItems/apps/index';
import quoteItemsTableReducer from './quoteItems/data/reducer';
import quoteItemsTableSaga from './quoteItems/data/sagas';
import materialPricing from './quoteItems/materialpricing/data/reducer';
import materialPricingSaga from './quoteItems/materialpricing/data/sagas';
import addOnModal from './quoteItems/modals/AddOn/data/reducer';
import addOnModalSaga from './quoteItems/modals/AddOn/data/sagas';
import bomRestructuringDrawerReducer from './quoteItems/modals/BOMRestructuring/data/reducer';
import bomRestructuringDrawerSaga from './quoteItems/modals/BOMRestructuring/data/sagas';
import confirmProcessMaterialModal from './quoteItems/modals/ConfirmProcessMaterial/data/reducer';
import confirmProcessMaterialSaga from './quoteItems/modals/ConfirmProcessMaterial/data/sagas';
import copyPricingDrawer from './quoteItems/modals/CopyPricingDrawer/data/reducer';
import copyPricingSaga from './quoteItems/modals/CopyPricingDrawer/data/sagas';
import discountModal from './quoteItems/modals/Discount/data/reducer';
import discountModalSaga from './quoteItems/modals/Discount/data/sagas';
import operationModal from './quoteItems/modals/Operation/data/reducer';
import operationModalSaga from './quoteItems/modals/Operation/data/sagas';
import profitItemModal from './quoteItems/modals/ProfitItem/data/reducer';
import profitItemModalSaga from './quoteItems/modals/ProfitItem/data/sagas';
import quantitiesModal from './quoteItems/modals/Quantities/data/reducer';
import quantitiesModalSaga from './quoteItems/modals/Quantities/data/sagas';
import replaceParentDrawer from './quoteItems/modals/ReplaceParentDrawer/data/reducer';
import replaceParentDrawerSaga from './quoteItems/modals/ReplaceParentDrawer/data/sagas';
import similarComponentsModal from './quoteItems/modals/SimilarComponents/data/reducer';
import customAttrsModalReducer from './quoteItems/modals/customAttrsModal/data/reducer';
import customAttrsModalSaga from './quoteItems/modals/customAttrsModal/data/sagas';
import geometricAttributesModalReducer from './quoteItems/modals/geometricAttributesModal/data/reducer';
import geometricAttributesModalSaga from './quoteItems/modals/geometricAttributesModal/data/sagas';
import makeAssemblyModalReducer from './quoteItems/modals/makeAssemblyModal/data/reducer';
import quoteRevisionDrawer from './quoteRevisionDrawer/data/reducer';
import quoteRevisionSaga from './quoteRevisionDrawer/data/sagas';
import routes from './routes';

const reducer = combineReducers({
  addOnModal,
  bomRestructuringDrawerReducer,
  discountModal,
  collaborators: collaboratorsReducer,
  confirmProcessMaterialModal,
  contactAndAccountNotes,
  copyPricingDrawer,
  customAttrsModal: customAttrsModalReducer,
  facilitateOrderDrawer,
  geometricAttributesModal: geometricAttributesModalReducer,
  importHistoricalWork: importHistoricalWorkReducer,
  makeAssemblyModal: makeAssemblyModalReducer,
  materialPricing,
  operationModal,
  profitItemModal,
  quantitiesModal,
  quoteDetails: quoteDetailsReducer,
  quoteItemComponents: quoteItemComponents.reducer,
  quoteItemNav: quoteItemNav.reducer,
  quoteItems: combineReducers({
    apps: quoteItemAppsReducer,
    table: quoteItemsTableReducer,
  }),
  quoteRevisionDrawer,
  similarComponentsModal,
  replaceParentDrawer,
});

const saga = function* () {
  yield all([
    addOnModalSaga(),
    bomRestructuringDrawerSaga(),
    discountModalSaga(),
    collaboratorsSaga(),
    confirmProcessMaterialSaga(),
    contactAndAccountNotesSaga(),
    copyPricingSaga(),
    customAttrsModalSaga(),
    geometricAttributesModalSaga(),
    materialPricingSaga(),
    operationModalSaga(),
    profitItemModalSaga(),
    quantitiesModalSaga(),
    quoteItemComponents.saga(),
    quoteItemNav.saga(),
    quoteItemsTableSaga(),
    quoteRevisionSaga(),
    replaceParentDrawerSaga(),
  ]);
};

export { reducer, routes, saga };
